import { render, staticRenderFns } from "./StartDialog.vue?vue&type=template&id=ef138078&scoped=true&"
import script from "./StartDialog.vue?vue&type=script&lang=js&"
export * from "./StartDialog.vue?vue&type=script&lang=js&"
import style0 from "./StartDialog.vue?vue&type=style&index=0&id=ef138078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef138078",
  null
  
)

export default component.exports